import { AppointmentListingModel, IModel, ModelRecord } from '@common/models';

export interface IAppointmentStatusRequest extends IModel {
  reservationId: number;
  visitId: number | undefined;
  shouldAutoLogIHDInteraction?: boolean;
  audioRecordingUsed?: boolean;
}

export class AppointmentStatusRequest
  implements ModelRecord<IAppointmentStatusRequest>
{
  reservationId: number;
  visitId: number | undefined;
  rowVersion: string;
  shouldAutoLogIHDInteraction: boolean;
  audioRecordingUsed: boolean;

  constructor(init?: Partial<IAppointmentStatusRequest>) {
    this.reservationId = _.defaultTo(init?.reservationId, 0);
    this.visitId = _.defaultTo(init?.visitId, 0);
    this.rowVersion = _.defaultTo(init?.rowVersion, '');
    this.shouldAutoLogIHDInteraction = _.defaultTo(
      init?.shouldAutoLogIHDInteraction,
      false,
    );
    this.audioRecordingUsed = _.defaultTo(init?.audioRecordingUsed, false);
  }

  static FromListingModel(model: AppointmentListingModel) {
    return new AppointmentStatusRequest({
      reservationId: model.reservationId,
      visitId: model.visitId,
      rowVersion: model.rowVersion,
    });
  }
}
